import React from 'react';
import useTypedPage from '@/Hooks/useTypedPage';
import axios from 'axios';
import InputError from '@/Components/InputError';
import Button from '@/Components/Button';

export default function CheckoutPlanButton({
  plan,
  active,
}: {
  plan: App.Data.PlanData;
  active: boolean;
}) {
  const { auth } = useTypedPage().props;
  const billableType = 'team';
  const billableId = auth.user?.current_team?.id;

  const [errors, setErrors] = React.useState([]);
  const [processing, setProcessing] = React.useState(false);

  const startSubscription = () => {
    setProcessing(true);

    // Create the subscription data payload
    const data = {
      plan: plan.id,
      billableType: billableType,
      billableId: billableId,
      direct: true, // Assuming the checkout should go directly to Stripe without collecting VAT or Billing Address
    };

    // Use Inertia to send the request to the Laravel backend
    axios
      .post('/spark/subscription', data)
      .then(response => {
        if (response && response.data && response.data.redirect) {
          window.location.href = response.data.redirect;
        } else {
          setProcessing(false);
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 422) {
          setErrors(Object.values(error.response.data.errors).flat());
        } else {
          setErrors([
            'An unexpected error occurred and we have notified our support team. Please try again later.',
          ]);
        }
      });
  };

  return (
    <div>
      {errors &&
        errors.length > 0 &&
        errors.map((error, index) => (
          <InputError key={index} message={error} />
        ))}

      <Button
        type="button"
        className="flex w-full justify-center bg-brand px-3 py-2 text-center text-sm capitalize text-brand-dark-75 disabled:bg-brand-dark-25 disabled:text-brand-light-25 dark:bg-brand-dark disabled:dark:bg-brand-dark-25 disabled:dark:text-brand-light-25"
        onClick={startSubscription}
        disabled={processing || active}
      >
        {active
          ? 'Your current plan'
          : processing
            ? 'Processing...'
            : `Upgrade to ${plan.name}`}
      </Button>
    </div>
  );
}
